import { render } from "./warheadSection.vue?vue&type=template&id=aff464ce&scoped=true"
import script from "./warheadSection.vue?vue&type=script&lang=js"
export * from "./warheadSection.vue?vue&type=script&lang=js"

import "./warheadSection.vue?vue&type=style&index=0&id=aff464ce&scoped=true&lang=css"

import exportComponent from "/data/PDBcov/VueJs/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aff464ce"]])

export default __exports__